import { FloatingPopover } from 'components/FloatingPopover/FloatingPopover'
import { type EditorView } from 'prosemirror-view'
import Styles from './TableRightClickMenu.module.scss'
import { ReactComponent as ChevronRight } from 'assets/icons/chevronRight.svg'
import {
  ClipboardOptions,
  FormatOption,
  FormatOptions,
  InsertOptions,
  MergeOptions,
  RemoveOptions,
  TableMenuItem,
} from './TableRightClickMenuItems'

interface Props {
  view: EditorView
  position: { x: number; y: number }
  closeMenu: Function
}

export const MENU_WIDTH = '204px'

const TableMenuContent = ({ view, position, closeMenu }: Props) => {
  const tableMenuRow = (item: TableMenuItem) => {
    return (
      <div
        className={Styles.menuItem}
        key={item.label}
        onClick={(e) => {
          item.run(view, position, e)
          closeMenu(view)
        }}
        data-testid={item.testId}
      >
        {<item.icon className={Styles.menuItemIcon} />}
        <span>{item.label}</span>
      </div>
    )
  }

  const tableMenuSection = (items: TableMenuItem[], showDivider: boolean) => {
    const filteredItems = items.filter((i) => i.enable(view.state))
    return (
      <>
        {filteredItems.map(tableMenuRow)}
        {!!filteredItems.length && showDivider && <div className={Styles.divider} />}
      </>
    )
  }

  const tableMenuFormatRow = (item: FormatOption) => {
    return (
      <FloatingPopover key={item.label} content={item.content(view, closeMenu)} placement="right-end">
        <div className={Styles.menuItem}>
          {<item.icon className={Styles.menuItemIcon} />}
          <span>{item.label}</span>
          <ChevronRight className={Styles.menuItemChevron} />
        </div>
      </FloatingPopover>
    )
  }

  const tableMenuFormatSection = () => {
    const filteredItems = FormatOptions.filter((i) => i.enable(view.state))
    return (
      <>
        {filteredItems.map(tableMenuFormatRow)}
        {!!filteredItems.length && <div className={Styles.divider} />}
      </>
    )
  }

  return (
    <div className={Styles.contentContainer} style={{ width: MENU_WIDTH }}>
      {tableMenuSection(ClipboardOptions, true)}
      {tableMenuFormatSection()}
      {tableMenuSection(MergeOptions, true)}
      {tableMenuSection(InsertOptions, true)}
      {tableMenuSection(RemoveOptions, false)}
    </div>
  )
}

export default TableMenuContent
